interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
}

/**
 * Get CSRF token from meta tag
 */
const getCsrfToken = (): string => {
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  return metaTag ? metaTag.getAttribute('content') || '' : '';
};

/**
 * Send loan application data to the server
 * @param formData Form data to submit
 * @returns Promise with API response
 */
export const submitLoanApplication = async (formData: FormData): Promise<ApiResponse<any>> => {
  try {
    const endpoint = formData.get('contactId') ? '/api/loan_form/update_contact' : '/api/loan_form/create_contact';
    
    const absoluteEndpoint = endpoint.replace(/^\/[a-z]{2}\//, '');
    
    const response = await fetch(absoluteEndpoint, {
      method: 'POST',
      body: formData,
      headers: {
        'X-CSRF-Token': getCsrfToken(),
      },
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      return {
        success: false,
        error: data.error || 'An unknown error occurred',
      };
    }
    
    return {
      success: true,
      data: data as any,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Network error occurred',
    };
  }
};

/**
 * Helper function to delay simulating API call in development
 * This can be removed in production
 */
export const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};